export default __webpack_public_path__ + "static/media/mushroomape.454a05c1.webp";